module.exports = __webpack_public_path__ + "static/media/opensans.28c32de9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/opensans.png
// module id = 1442
// module chunks = 0